/*

Ashraf 11/27/2022 2698948956 Initial tabs for data repository
Gummala Prakash 11/29/2022 2698948956 Added card Styles.
*/

import React, {useContext, useEffect} from 'react';
import SubTabsContent from './SubTabsContent';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useDispatch} from 'react-redux';
import {setReduxState} from '../../../../redux/reducers/BRE/AddRuleGroup';

const DataRepositories = ({tabValue, setTabValue, StepperFieldList}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setReduxState({property: 'formData', value: {}}));
    dispatch(setReduxState({property: 'category', value: ''}));
  }, []);

  return (
    <div className={` ${classes.cardStyleWhite}`}>
      <SubTabsContent setTabValue={setTabValue} StepperFieldList={StepperFieldList} />
    </div>
  );
};

export default DataRepositories;
